// extracted by mini-css-extract-plugin
export default {"container":"banners_container__fD3WW","banner":"banners_banner__WimEb"};